import React, { useState } from "react";
import { Camera, Crown } from "lucide-react";
import { Slider } from "@/components/finishing/Controls";

const FIELDS = ["exposure", "temperature", "tint", "saturation", "contrast"];
const rgb = (s) => `rgb(${Math.round(s.r * 255)},${Math.round(s.g * 255)},${Math.round(s.b * 255)})`;

const Stat = ({ k, v }) => (
  <div><div className="metric-label" style={{ fontSize: 9 }}>{k}</div><div className="font-mono text-xs">{v}</div></div>
);

export const CameraCard = ({ cam, isHero, onHero, onTweak }) => {
  const [m, setM] = useState({ exposure: 0, temperature: 0, tint: 0, saturation: 0, contrast: 0, ...(cam.manual || {}) });
  const s = cam.stats || {};
  const match = Object.entries(cam.match || {}).map(([k, v]) => `${k} ×${v}`).join(" · ");
  return (
    <div className={`studio-card p-4 space-y-3 ${isHero ? "border-[#E6B04E]" : ""}`} data-testid={`camera-card-${cam.id}`}>
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg border border-[#252A3B]" style={{ background: rgb(s) }} title="average colour" />
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-sm truncate flex items-center gap-1.5"><Camera size={14} className="text-[#64748B]" />{cam.label}</div>
          <div className="metric-label" style={{ fontSize: 9 }}>{cam.clips} clip(s)</div>
        </div>
        {isHero ? <span className="chip bg-[#E6B04E]/15 text-[#E6B04E]" data-testid={`camera-hero-badge-${cam.id}`}><Crown size={11} />HERO</span>
          : <button className="btn btn-ghost !py-1 !px-2 text-xs" onClick={onHero} data-testid={`camera-set-hero-${cam.id}`}>Set hero</button>}
      </div>
      <div className="grid grid-cols-4 gap-2">
        <Stat k="Luma" v={s.luma} /><Stat k="Contrast" v={s.contrast} /><Stat k="Sat" v={s.saturation} /><Stat k="R/G/B" v={`${s.r}/${s.g}/${s.b}`} />
      </div>
      <p className="text-[11px] font-mono text-[#5fe9f5] min-h-[16px]" data-testid={`camera-match-${cam.id}`}>
        {isHero ? "reference look for all cameras" : (match ? `match → ${match}` : "already matched")}
      </p>
      <div className="grid grid-cols-2 gap-x-4 gap-y-2">
        {FIELDS.map((f) => (
          <Slider key={f} label={f} value={m[f]} testid={`camera-${cam.id}-${f}`}
            onChange={(v) => setM({ ...m, [f]: v })} onCommit={(v) => onTweak({ ...m, [f]: v })} />
        ))}
      </div>
    </div>
  );
};
